import React from "react";
import styles from "./STHeroCommon.module.css";
import clsx from "clsx";
import Image from "next/image";

const parseDraftOrRaw = (content) => {
  if (!content) return "";
  if (typeof content === "object") {
    if (content.blocks && Array.isArray(content.blocks)) {
      return content.blocks.map((b) => b.text).filter(Boolean).join("\n");
    }
  }
  if (typeof content === "string") {
    try {
      const parsed = JSON.parse(content);
      if (parsed?.blocks && Array.isArray(parsed.blocks)) {
        return parsed.blocks.map((b) => b.text).filter(Boolean).join("\n");
      }
    } catch (e) {
      // raw string
    }
  }
  return String(content);
};

const isVideoUrl = (url, isVideoFlag = false) => {
  if (!url) return false;
  if (typeof url !== "string") return false;

  const cleanUrl = url.split("?")[0].split("#")[0].toLowerCase();
  const videoExtensions = [".mp4", ".webm", ".ogg", ".mov", ".m4v", ".mkv", ".avi"];
  const imageExtensions = [".jpg", ".jpeg", ".png", ".webp", ".gif", ".svg", ".avif", ".bmp", ".ico"];

  if (videoExtensions.some((ext) => cleanUrl.endsWith(ext))) {
    return true;
  }
  if (imageExtensions.some((ext) => cleanUrl.endsWith(ext))) {
    return false;
  }

  return Boolean(isVideoFlag);
};

export const STHeroCommon = ({
  title,
  description,
  extraContent,
  bgImage,
  bgVideo,
  isVideo,
}) => {
  const parsedTitle = parseDraftOrRaw(title);
  const parsedDescription = parseDraftOrRaw(description);

  const activeMedia = bgVideo || bgImage;
  const isMediaVideo = isVideoUrl(activeMedia, isVideo);
  const mediaVideo = isMediaVideo ? activeMedia : null;
  const mediaImage = !isMediaVideo ? bgImage : null;

  return (
    <section
      className={clsx(
        styles.heroCommon,
        "d-flex justify-content-center align-items-center bg-black position-relative overflow-hidden",
      )}
    >
      {/* Background Video */}
      {mediaVideo && (
        <video
          src={mediaVideo}
          autoPlay
          muted
          loop
          playsInline
          controls={false}
          disablePictureInPicture
          style={{ pointerEvents: "none" }}
          className={clsx(
            styles.heroBgMedia,
            "position-absolute top-0 start-0 w-100 h-100 object-fit-cover z-0",
          )}
        />
      )}

      {/* Background Image */}
      {!mediaVideo && mediaImage && (
        typeof mediaImage === "string" ? (
          <img
            src={mediaImage}
            alt=""
            className={clsx(
              styles.heroBgMedia,
              "position-absolute top-0 start-0 w-100 h-100 object-fit-cover z-0",
            )}
          />
        ) : (
          <Image
            src={mediaImage}
            alt=""
            fill
            className={clsx(
              styles.heroBgMedia,
              "position-absolute top-0 start-0 w-100 h-100 object-fit-cover z-0",
            )}
          />
        )
      )}

      {/* Overlay for Image/Video */}
      {(mediaVideo || mediaImage) && (
        <div
          className={clsx(
            styles.heroOverlay,
            "position-absolute top-0 start-0 w-100 h-100 z-1",
          )}
        />
      )}

      <div className="container position-relative z-2">
        <div className="d-flex justify-content-center align-items-center">
          <div className={clsx(styles.heroCommonContent, "text-center")}>
            <h1 className={"fw-normal text-white mb-0"}>{parsedTitle || title}</h1>
            {(parsedDescription || description) && (
              <p
                className={clsx(
                  styles.heroCommonDescription,
                  "paragraph-text mb-0 space-sm-mt text-clr-white-55",
                )}
              >
                {parsedDescription || description}
              </p>
            )}
            {extraContent}
          </div>
        </div>
      </div>
    </section>
  );
};

